import React from "react";
import ReusableDataTable from "../../hooks/ReusableDataTable";
import { Button, Label, Modal, TextInput, Avatar, Select, } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import '../../style/model.css';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import useInputValidation from "../../hooks/useInputValidation";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
import { useSidebar } from "../../context/SidebarOpenContext";

function Marker() {
    const [AddModal, setAddModal] = useState(false);
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [Input, setInput] = useState({});
    const [Marker, setMarker] = useState({});
    const [error, setError] = useState({});
    const { errors, handleChange, resetErrors } = useInputValidation();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    useEffect(() => {
        fetchmarker();
    }, []);


    const onChangeValue = (e) => {
        const { name, value } = e.target;
        const updatedInput = {
            ...Input,
            [name]: value
        };
        setInput(updatedInput);

        if (name === "mname") {
            let type = Input.markertype;
            let pattern = {
                numbers: /^[0-9]+$/,
                letters: /^[A-Za-z]+$/,
                Albanumeric: /^[A-Za-z0-9]+$/
            }[type];

            if (type && !pattern.test(value)) {
                setError(prev => ({
                    ...prev,
                    mname: `Only ${type} characters are allowed`
                }));
            } else {
                setError(prev => ({
                    ...prev,
                    mname: null
                }));
            }
        }

        if (name === "markertype") {
            setError(prev => ({ ...prev, mname: null }));
        }
    };


    const fetchmarker = async () => {
        try {
            const response = await axios.get("master/size_variants");
            const markerData = response.data;
            setMarker(markerData);
        } catch (error) {
            console.error("Error fetching Size data:", error);
        }
    };

    const addMarker = async (event) => {
        event.preventDefault();
        try {
            axios
                .post(`master/size_variants`, {
                    size: Input.mname,
                    type: Input.markertype
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Size  Created",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setAddModal(false);
                        fetchmarker();


                    } else if (res.data.success === 2) {
                        Swal.fire({
                            icon: "error",
                            text: "Size  already exists...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const UpdateMarker = async (event) => {
        event.preventDefault();

        try {
            axios
                .put(`master/size_variants/${Input.id}`, {
                    size: Input.mname,
                    type: Input.markertype,
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Size  Details Updated",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setEditModal(false);
                        fetchmarker();
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const deletMarker = async () => {
        try {
            axios.delete(`master/size_variants/${Input.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Size  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchmarker();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };


    const data = Array.isArray(Marker)
        ? Marker.map((M) => ({
            id: M.size_id,
            mname: M.size,
            markertype: M.type,
            option: (<div style={{ display: "flex" }}>
                <FaPen className="text-amber-400 text-xl" onClick={() => {
                    setEditModal(true); setInput({
                        id: M.size_id,
                        mname: M.size,
                        markertype: M.type,

                    });
                }} />
                <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setInput({ id: M.size_id }) }} />
            </div>)
        }))
        : [];


    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Size", selector: (row) => row.mname, sortable: true },
        { name: "Type", selector: (row) => row.markertype, sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    return (

        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700  mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" onClick={() => setAddModal(true)} >Add Size</Button>
                    <ReusableDataTable
                        title="Size List"
                        columns={columns}
                        data={data}
                    />
                </div>
            </div>

            <Modal show={AddModal} size="md" onClose={() => { setAddModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Size</h3>
                        <form onSubmit={addMarker}>

                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="stock" value="Size Type" />
                                </div>
                                <Select id="markertype" name="markertype" onChange={onChangeValue} required>
                                    <option value="">Select an option</option>
                                    <option value="numbers">Numbers</option>
                                    <option value="letters">Letters</option>
                                    <option value="Albanumeric">Albanumeric</option>
                                </Select>
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.mname && "failure"} value="Size" />
                                </div>
                                <TextInput
                                    id="mname"
                                    name="mname"
                                    placeholder=""
                                    type="text"
                                    color={error.mname && "failure"}
                                    helperText={
                                        error.mname && (
                                            <>
                                                <span className="font-medium"></span> {error.mname}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    required
                                    value={Input.mname}
                                    pattern={
                                        Input.markertype === "numbers" ? "[0-9]+" :
                                            Input.markertype === "letters" ? "[A-Za-z]+" :
                                                Input.markertype === "Albanumeric" ? "^[A-Za-z0-9]+$" :
                                                    ".*"
                                    }
                                />

                            </div>
                            <div className="pt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setAddModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => { setEditModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Update Size</h3>
                        <form onSubmit={UpdateMarker}>

                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="stock" value="Size Type" />
                                </div>
                                <Select id="markertype" name="markertype" onChange={onChangeValue} value={Input.markertype} required>
                                    <option value="">Select an option</option>
                                    <option value="numbers">Numbers</option>
                                    <option value="letters">Letters</option>
                                    <option value="Albanumeric">Albanumeric</option>
                                </Select>
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.mname && "failure"} value="Size" />
                                </div>
                                <TextInput
                                    id="mname"
                                    name="mname"
                                    placeholder=""
                                    type="text"
                                    color={error.mname && "failure"}
                                    helperText={
                                        error.mname && (
                                            <>
                                                <span className="font-medium"></span> {error.mname}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    required
                                    value={Input.mname}
                                    pattern={
                                        Input.markertype === "numbers" ? "[0-9]+" :
                                            Input.markertype === "letters" ? "[A-Za-z]+" :
                                                Input.markertype === "Albanumeric"
                                                    ? "^[A-Za-z0-9]+$" :
                                                    ".*"
                                    }
                                />

                            </div>
                            <div className="pt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setEditModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>

                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to delete this Size?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => deletMarker()}>
                                {"Yes"}
                            </Button>
                            <Button className="ml-2" color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>


    );
}

export default Marker;
